import ccpInitMiddleware from './ccp.app';
import ccpAgentMiddleware from './ccp.agent';
import ccpContactMiddleware from './ccp.contact';

const ccp = [ccpInitMiddleware, ccpAgentMiddleware, ccpContactMiddleware]

export default ccp;